import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import { useAdminAuth } from '~/hooks/adminAuth';
import getInitialLettersOfName from '~/utils/getInitialLettersOfName';

import Notifications from './Notifications';

// import logo from '~/assets/logo-color.png';

const Admin: React.FC = ({ children }) => {
  const { user, signOut } = useAdminAuth();

  const initials = useMemo(() => {
    return getInitialLettersOfName(user.name);
  }, [user.name]);

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href={`${process.env.PUBLIC_URL}/assets/css/dashlite.css`}
        />
      </Helmet>

      <div className="nk-app-root">
        <div className="nk-apps-sidebar is-theme">
          {/* <div className="nk-apps-brand">
            <Link to="/" className="logo-link">
              <img className="logo-light logo-img" src={logo} alt="logo" />
              <img className="logo-dark logo-img" src={logo} alt="logo-dark" />
            </Link>
          </div> */}
          <div className="nk-sidebar-element">
            <div className="nk-sidebar-body">
              <div className="nk-sidebar-content" data-simplebar>
                <div className="nk-sidebar-menu">
                  <ul className="nk-menu apps-menu">
                    {/* <li className="nk-menu-item">
                      <Link
                        to="/"
                        className="nk-menu-link"
                        title="Analytics Dashboard"
                      >
                        <span className="nk-menu-icon">
                          <em className="icon ni ni-dashboard" />
                        </span>
                      </Link>
                    </li> */}
                    <li className="nk-menu-item">
                      <Link to="/" className="nk-menu-link" title="Dashboard">
                        <span className="nk-menu-icon">
                          <em className="icon ni ni-grid" />
                        </span>
                      </Link>
                    </li>
                    <li className="nk-menu-item">
                      <Link
                        to="/companies"
                        className="nk-menu-link"
                        title="Estabelecimentos"
                      >
                        <span className="nk-menu-icon">
                          <em className="icon ni ni-building" />
                        </span>
                      </Link>
                    </li>
                    <li className="nk-menu-item">
                      <Link
                        to="/payments"
                        className="nk-menu-link"
                        title="Pagamentos"
                      >
                        <span className="nk-menu-icon">
                          <em className="icon ni ni-invest" />
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* <div className="nk-sidebar-footer">
                  <ul className="nk-menu nk-menu-md">
                    <li className="nk-menu-item">
                      <Link
                        to="/settings"
                        className="nk-menu-link"
                        title="Settings"
                      >
                        <span className="nk-menu-icon">
                          <em className="icon ni ni-setting" />
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
              <div
                className="nk-sidebar-profile nk-sidebar-profile-fixed"
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <ul className="nk-menu nk-menu-md">
                  {/* <li className="nk-menu-item">
                    <Link
                      to="/settings"
                      className="nk-menu-link"
                      title="Settings"
                    >
                      <span className="nk-menu-icon">
                        <em className="icon ni ni-setting" />
                      </span>
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="nk-main ">
          <div className="nk-wrap ">
            <div className="nk-header nk-header-fixed is-light">
              <div className="container-fluid">
                <div className="nk-header-wrap">
                  <div className="nk-header-app-name">
                    {/* <div className="nk-header-app-logo">
                    <em className="icon ni ni-dashlite bg-purple-dim" />
                  </div> */}
                    <div className="nk-header-app-info">
                      {/* <span className="sub-text">DashLite</span> */}
                      <span className="lead-text">
                        {`${process.env.REACT_APP_APP_NAME} - Administrativo`}
                      </span>
                    </div>
                  </div>

                  <div className="nk-header-tools">
                    <ul className="nk-quick-nav">
                      <li className="dropdown notification-dropdown">
                        <Notifications />
                      </li>
                      <li className="dropdown list-apps-dropdown d-lg-none">
                        <Link
                          to="#menu"
                          className="dropdown-toggle nk-quick-nav-icon"
                          data-toggle="dropdown"
                        >
                          <div className="icon-status icon-status-na">
                            <em className="icon ni ni-menu-circled" />
                          </div>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                          <div className="dropdown-body">
                            <ul className="list-apps">
                              {/* <li>
                                <Link to="/">
                                  <span className="list-apps-media">
                                    <em className="icon ni ni-dashboard" />
                                  </span>
                                  <span className="list-apps-title">
                                    Dashboard
                                  </span>
                                </Link>
                              </li> */}
                              <li>
                                <Link to="/">
                                  <span className="list-apps-media">
                                    <em className="icon ni ni-invest" />
                                  </span>
                                  <span className="list-apps-title">
                                    Dashboard
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li className="dropdown user-dropdown">
                        <Link
                          to="#profile"
                          className="dropdown-toggle mr-n1"
                          data-toggle="dropdown"
                        >
                          <div className="user-toggle">
                            <div className="user-avatar sm">
                              <em className="icon ni ni-user-alt" />
                            </div>
                          </div>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-md dropdown-menu-right">
                          <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                            <div className="user-card">
                              <div className="user-avatar">
                                <span>{initials}</span>
                              </div>
                              <div className="user-info">
                                <span className="lead-text">{user.name}</span>
                                <span className="sub-text">{user.email}</span>
                              </div>
                            </div>
                          </div>
                          <div className="dropdown-inner">
                            <ul className="link-list">
                              <li>
                                <Link to="/settings">
                                  <em className="icon ni ni-setting-alt" />
                                  <span>Configurações</span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div className="dropdown-inner">
                            <ul className="link-list">
                              <li>
                                <Link to="#signout" onClick={signOut}>
                                  <em className="icon ni ni-signout" />
                                  <span>Sair</span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="nk-content ">
              <div className="container-fluid">
                <div className="nk-content-inner">
                  <div className="nk-content-body">{children}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
